import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Checkout from "./Checkout";
import OrderDetail from "./OrderDetail";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_CONFIG } from "../share/common";
import { useHistory } from "react-router";
import Footer from "./Footer";

function CheckoutControl() {
  const user = useSelector((state) => state.user_auth);
  const products = useSelector((state) => state.shoppingCart);
  const [userInfo, setUserInfo] = useState({});
  const [cardInfo, setCardInfo] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const init = async () => {
      const { data } = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + "/users/" + user.userName,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      setUserInfo(data);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const checkout = async () => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_API_URL + "/orders",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: {
          ...userInfo,
          ...cardInfo,
          products,
          userId: user.id,
        },
      });
      console.log("RESPONSE : ", response);
      if (response.status === 201) {
        toast.success("Orden creada con éxito", TOAST_CONFIG);
        dispatch({
          type: "REMOVE_ITEMS_FROM_CART",
        });
        history.push("/gracias");
      } else if (response.status === 206) {
        toast.error(`😪 ${response.data.message}`, TOAST_CONFIG);
      } else {
        toast.error(response, TOAST_CONFIG);
      }
    } catch (error) {
      console.log(error.message);
      toast.error(error.message, TOAST_CONFIG);
    }
  };

  return (
    <>
      <div className="container checkout_container mb-3">
        <div className="row">
          <div className="col-lg-7">
            <Checkout userInfo={userInfo} setUserInfo={setUserInfo} />
          </div>
          <div className="col-lg-5 mt-4 mb-4">
            <OrderDetail cardInfo={cardInfo} setCardInfo={setCardInfo} checkout={checkout} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CheckoutControl;
